import { FeatureMiddleware } from '../featureInterface';
import { createFeatureNumericMiddleware } from './numeric';

export function createFeatureTraitMiddleware(): FeatureMiddleware[] {
    return [createFeatureNumericMiddleware()];
}
